import { useApolloClient } from '@apollo/client';
import { dayFormatType, formatDay, moment } from '~helpers/day';
import { message } from 'antd';
import exportToCsv from '~helpers/export-csv';
import { get } from 'lodash';
import { useCallback, useState } from 'react';
import { QUERY_LIST_PARTNERS } from './queries';

export default function useExportPartner() {
  const client = useApolloClient();
  const [isLoading, setIsLoading] = useState(false);

  const handleExportCSV = useCallback(async ({ queryFilter, totalCount = 999 }) => {
    try {
      setIsLoading(true);
      const queryResponse = await client.query({
        query: QUERY_LIST_PARTNERS,
        variables: {
          pageNumber: 1,
          pageSize: totalCount,
          sortBy: 'UPDATED_AT',
          sortDirection: 'DESCENDING',
          name: queryFilter.accountName || null,
          partnerCode: queryFilter.partnerCode || null,
          referrerId: queryFilter.referrerId || null,
          phoneNumber: queryFilter.phoneNumber || null,
          emailAddress: queryFilter.emailAddress || null,
          country: queryFilter.country || null,
          enabled: typeof queryFilter.enabled === 'boolean' ? queryFilter.enabled : null,
        },
        fetchPolicy: 'no-cache',
      });

      const allListData = queryResponse?.data?.listPartners?.edges.map(edge => edge.node) || [];
      const csvData = allListData.map(item => {
        const csvColumns = [];
        [
          'name',
          'country',
          'partnerCode',
          'commissionPlan.name',
          'payoutPlan.name',
          {
            key: 'internalReferrer',
            transfer: record => `${record?.firstName || '-'} ${record?.lastName || '-'}`,
          },
          'enabled',
          {
            key: 'createdAt',
            transfer: record => `\t${formatDay(dayFormatType.UKWITHHM, record)}\t`,
          },
          {
            key: 'updatedAt',
            transfer: record => `\t${formatDay(dayFormatType.UKWITHHM, record)}\t`,
          },
        ].map(dataKey => {
          if (typeof dataKey === 'string') {
            csvColumns.push(get(item, dataKey) || '-');
          } else {
            csvColumns.push(dataKey.transfer(get(item, dataKey.key)));
          }
        });
        return csvColumns;
      });

      exportToCsv(`[Student.com][PartnerAccount]-${moment().format(dayFormatType.UKWITHHM)}.csv`, [
        [
          'Account Name',
          'Country',
          'Partner Code',
          'CommissionPlan Name',
          'Payout Plan Name',
          'Account Owner',
          'Status',
          'Create Date',
          'Update Date',
        ],
        ...csvData,
      ]);
      setIsLoading(false);
    } catch (e) {
      message.error(e?.toString());
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { exportToCSV: handleExportCSV, isLoading };
}
